import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=19f41aeb&scoped=true&"
import script from "./resetPwd.vue?vue&type=script&lang=js&"
export * from "./resetPwd.vue?vue&type=script&lang=js&"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=19f41aeb&lang=scss&scoped=true&"
import style1 from "./resetPwd.vue?vue&type=style&index=1&id=19f41aeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f41aeb",
  null
  
)

export default component.exports